import ConfigProvider from '../Core/Configuration/ConfigProvider';

const LNComscore = {
    TriggerPageView() {
        $.get(ConfigProvider.Sitio.Url + 'Comscore/PageView');

        self.COMSCORE && COMSCORE.beacon({
            c1: '2',
            c2: ConfigProvider.Comscore.Id
        });
    }
};

$(function () {
    var notasSugeridasLlamado = false;

    window.addEventListener('scroll', function () {
        const position = $(this).scrollTop();

        const $notasSugeridas = !notasSugeridasLlamado && $('#notas-sugeridas');

        if ($notasSugeridas && $notasSugeridas.length) {
            var triggerNotasSugeridas = position >= $notasSugeridas.position().top;

            if (triggerNotasSugeridas) {
                notasSugeridasLlamado = true;

                LNComscore.TriggerPageView();
            }
        }
    });
});

export default LNComscore;


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/LNComscore.js